import { createContext } from 'react'
import { sponsorTypesInitialState } from './sponsorTypesInitialState'

const SponsorTypesContext = createContext(sponsorTypesInitialState)

export default SponsorTypesContext
